import { el } from '../lib/dom.js';

type NavKey = 'home' | 'history' | 'prs' | 'evolution';

const ITEMS: { key: NavKey; label: string; href: string }[] = [
  { key: 'home', label: 'Hoje', href: '/' },
  { key: 'history', label: 'Histórico', href: '/history' },
  { key: 'evolution', label: 'Evolução', href: '/evolution' },
  { key: 'prs', label: 'PRs', href: '/prs' },
];

export function renderNav(active: NavKey) {
  return el(
    'nav',
    { class: 'nav' },
    ITEMS.map((it) =>
      el(
        'a',
        {
          class: 'nav__item',
          href: `#${it.href}`,
          'aria-current': active === it.key ? 'page' : undefined,
        },
        [it.label],
      ),
    ),
  );
}
